import { useEffect, useState } from "react";
import { Card, Spinner } from "reactstrap";

import PrivateChatService from "../Services/PrivateChatService";
import PrivateChatHubService from "../Hub/PrivateChatHubService";

import {
    PrivateConversation,
    PrivateMessage
} from "../types/PrivateChat";

import PrivateMessageList from "../Components/PrivateMessageList";
import PrivateMessageInput from "../Components/PrivateMessageInput";
import TypingIndicator from "../Components/TypingIndicator";
import { useAuth } from "../../../../context/AuthContext";

interface Props {

    groupId: string;
}

const CustomerCoordinatorChat = ({
    groupId,
}: Props) => {

    const { token } = useAuth();
    const [loading, setLoading] = useState(true);

    const [conversation, setConversation] =
        useState<PrivateConversation | null>(null);

    const [messages, setMessages] =
        useState<PrivateMessage[]>([]);

    const [typing, setTyping] =
        useState(false);

    // -----------------------------
    // LOAD
    // -----------------------------

    useEffect(() => {

        load();

        // eslint-disable-next-line
    }, [groupId]);

    const load = async () => {

        try {

            const conv =
                await PrivateChatService.getConversation(
                    groupId
                );

            setConversation(conv);

            const history =
                await PrivateChatService.getMessages(
                    conv.conversationId
                );

            setMessages(history);

            await connectHub(
                conv.conversationId
            );

        }
        finally {

            setLoading(false);

        }
    };

    // -----------------------------
    // SIGNALR
    // -----------------------------

    const connectHub = async (
        conversationId: string
    ) => {

        if (!token)
            return;

        await PrivateChatHubService.start(token);

        PrivateChatHubService.onReceiveMessage(
            (message: PrivateMessage) => {

                if (
                    message.conversationId !==
                    conversationId
                )
                    return;

                setMessages(prev => [

                    ...prev,

                    message

                ]);

                PrivateChatHubService.markDelivered(
                    message.privateMessageId
                );

            });

        PrivateChatHubService.onUserTyping(
            () => {

                setTyping(true);

            });

        PrivateChatHubService.onUserStoppedTyping(
            () => {

                setTyping(false);

            });

        PrivateChatHubService.onMessagesRead(
            () => {

                setMessages(prev =>

                    prev.map(x => ({

                        ...x,

                        isRead: true

                    }))

                );

            });

        PrivateChatHubService.onMessageDelivered(
            (messageId: string) => {

                setMessages(prev =>

                    prev.map(x =>

                        x.privateMessageId === messageId

                            ? {

                                ...x,

                                isDelivered: true

                            }

                            : x

                    )

                );

            });

        await PrivateChatHubService.markRead(
            conversationId
        );
    };

    // -----------------------------
    // SEND
    // -----------------------------

    const sendMessage = async (
        text: string
    ) => {

        if (!conversation)
            return;

        await PrivateChatHubService.sendMessage({

            conversationId:
                conversation.conversationId,

            message: text,

            messageType: 0

        });

    };

    // -----------------------------

    if (loading)
        return <Spinner />;

    return (

        <Card 
    className="d-flex flex-column border rounded"
    style={{
        height: "70vh",backgroundColor:'#d1e7dd'
    }} 
>

          

            <PrivateMessageList
                messages={messages}
            />

            <TypingIndicator
                typing={typing}
                userName="Coordinator"
            />

            <PrivateMessageInput

                onSend={sendMessage}

                onTyping={() => {

                    if (!conversation)
                        return;

                    PrivateChatHubService.typing(
                        conversation.conversationId
                    );

                }}

                onStopTyping={() => {

                    if (!conversation)
                        return;

                    PrivateChatHubService.stopTyping(
                        conversation.conversationId
                    );

                }}

            />

        </Card>

    );
};

export default CustomerCoordinatorChat;